module.exports = __webpack_public_path__ + "img/img43.ca16a107.svg";